export default "__VITE_ASSET__b122359b__"